import { render, staticRenderFns } from "./majorSelectedSubjects.vue?vue&type=template&id=0be479f1&scoped=true"
import script from "./majorSelectedSubjects.vue?vue&type=script&lang=js"
export * from "./majorSelectedSubjects.vue?vue&type=script&lang=js"
import style0 from "./majorSelectedSubjects.vue?vue&type=style&index=0&id=0be479f1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be479f1",
  null
  
)

export default component.exports